import React from 'react'
import Radio from '@components/Radio/Radio'
import { QontoLogo } from '@assets/svg'
import Button from '@components/Button'

interface RadioCardProps {
  selected: boolean
  onClick?: React.DOMAttributes<HTMLButtonElement>['onClick']
  children: React.ReactNode
}

interface Props {
  selected: boolean
  setSelected: (value: boolean) => void
  singleButton?: boolean
}

const RadioCard = ({ selected, onClick, children }: RadioCardProps) => {
  const color = selected ? 'black' : 'border-verylight-gray'

  return (
    <div className={`md:basis-1/2 flex text-center py-6 px-12 rounded-lg border-1 border-${color} mb-3 cursor-pointer relative`} onClick={onClick}>
      <div className="absolute top-3 right-3">
        <Radio selected={selected} />
      </div>
      {children}
    </div>
  )
}

const QontoForm = ({ selected, setSelected, singleButton }: Props) => {
  return (
    <div className="">
      <QontoLogo className="mx-auto mb-3 h-[26px] w-auto" />
      <h2 className="[&&]:text-base [&&]:text-center [&&]:p-0 mb-4">Le compte pro français le plus recommandé, maintenant rémunéré</h2>
      <div className="bg-new-verylight-gray border-verylight-gray border-1 rounded-lg flex pl-3 pr-4 py-4 mb-8">
        <div className="h-5 w-5 mr-2 shrink-0 text-sm items-baseline">💡</div>
        <div className="text-sm text-left items-baseline italic">Chez Ma Domiciliation.fr, on accompagne chaque jour des entrepreneurs comme vous. C’est pourquoi on recommande vivement Qonto, le compte pro en ligne pensé pour simplifier la vie des indépendants et petites entreprises.<br/>Plus de 600 000 entrepreneurs utilisent Qonto au quotidien pour piloter leur activité.</div>
      </div>
      <ul className="text-left text-sm mb-8 ml-[30px] [&&]:list-[circle]">
        <li>3 mois offerts dès l'ouverture de votre compte professionnel</li>
        <li>Ouverture de compte 100% en ligne en moins de 10 min</li>
        <li>Jusqu'à 4% de rémunération sur le solde de votre compte</li>
        <li>Support client disponible 7j/7, 24h/24.</li>
      </ul>
      {singleButton ? 
        (
          <div className="flex flex-col md:flex-row gap-3">
            <Button
              onClick={() => setSelected(true)}
              className='max-w-[300px] mx-auto'
            >
              Je souhaite être contacté
            </Button>
          </div>
        ) : (
        <div className="flex flex-col md:flex-row gap-3">
          <RadioCard
            selected={selected}
            onClick={() => setSelected(true)}
          >
            <div className="text-center">
              <div className="text-sm">Je découvre l'offre et je bénéficie de l'avantage exclusif*</div>
            </div>
          </RadioCard>
          <RadioCard
            selected={!selected}
            onClick={() => setSelected(false)}
          >
            <div className="text-center mx-auto">
              <div className="text-sm">Je ne suis pas intéressé(e)</div>
            </div>
          </RadioCard>
        </div>
      )}
    </div>
  )
}

export default QontoForm